var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGolf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.5271,
    height: 50,
    viewBox: "0 0 38.5271 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#bc5b28;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-golf") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M44.2635,19.2638A19.2635,19.2635,0,1,0,17.3044,36.9127c.0249.05.0325.1057.062.1547l.12.2c1.7831,2.9615,2.5211,4.1873,2.5211,7.0308v1.6408a2.0794,2.0794,0,0,0,.8912,1.6846l2.7545,1.9528a2.3531,2.3531,0,0,0,2.6949,0l2.754-1.9528a2.0776,2.0776,0,0,0,.8918-1.6846V44.2978c0-2.8414.7369-4.0667,2.519-7.0276l.1211-.2012c.03-.05.0377-.1056.063-.1569A19.2843,19.2843,0,0,0,44.2635,19.2638Zm-20.9,19.4929a26.7112,26.7112,0,0,0,3.2728.0037,12.5764,12.5764,0,0,0-1.12,5.5374v.5878L25,45.2507l-.5152-.3651v-.5878A12.5821,12.5821,0,0,0,23.3631,38.7567ZM25,34.482A15.2182,15.2182,0,1,1,40.218,19.2638,15.2353,15.2353,0,0,1,25,34.482Z",
    transform: "translate(-5.7365)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGolf);
export default __webpack_public_path__ + "static/media/icon-golf.61a23958127fbb84decc467db79b8201.svg";
export { ForwardRef as ReactComponent };